// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPathStatus_container__TXKaY","cta":"UserPathStatus_cta__weWHA","ctaActive":"UserPathStatus_ctaActive__4WNVj","ctaIcon":"UserPathStatus_ctaIcon__sPx0D"};